import { render, staticRenderFns } from "./Query.vue?vue&type=template&id=fff391e4&lang=pug&"
import script from "./Query.vue?vue&type=script&lang=ts&"
export * from "./Query.vue?vue&type=script&lang=ts&"
import style0 from "./Query.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports